<template lang="html">

  <div class="pe_game-menu">
    <div class="pe_game-menu-left">
      <span style="height:25px;width:25px; margin-right: 0.8em;">
        <svg id="pe_mini_logo_Svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 220 220">

          <path class="pe_logo-cls-1" d="m199.54,56.17c-9.01-15.51-21.32-27.42-36.96-35.71-15.63-8.29-33.17-12.44-52.59-12.44s-36.96,4.15-52.59,12.44c-15.63,8.29-27.96,20.2-36.96,35.71-9,15.52-13.5,33.46-13.5,53.83s4.44,38.61,13.33,54.01c8.88,15.4,21.08,27.24,36.6,35.53,15.51,8.3,32.99,12.44,52.41,12.44s37.01-4.14,52.76-12.44c15.75-8.29,28.19-20.19,37.31-35.71,9.12-15.51,13.68-33.46,13.68-53.83s-4.5-38.31-13.5-53.83Zm-89.54,111.03c-22.84-12.71-58.54-45.71-57.08-75.02,1.51-30.28,40.28-43.17,57.08-11.62,16.8-31.55,55.57-18.66,57.08,11.62,1.46,29.31-34.24,62.31-57.08,75.02Z"/>
        </svg>
      </span>
      <span class="pe_game-title">
        {{ titleHtml }} <span v-show="puzzleType != 'trivia'"> - <span :class="['pe_capitalize ',menuModeTextClass ]">{{ gameMode }} mode</span> </span>
      </span>
    </div>
    <div class="pe_align-center">


      <HintMenu2
        v-show="!showMainHintButton() && gameMode == 'quick' && allowHints"
      />

      <!--
      <span 
        class="pe_btn pe_hints-used"
        v-if="hintsUsed > 0"
      >
        Hints used: {{ hintsUsed }}
      </span>
    -->
      

      <button 
        :class="['pe_btn pe_menu ', hintBtnClass]"
        v-show="showMainHintButton() && gameMode == 'quick' && allowHints"
        @click="hintBtn($event)"
      >
        Hint 
      </button>

      <Stopwatch 
        v-show="showTimer && showMenuButtons" 
        :localSave="true"
      />

      <PausePlay 
        @play-pause="pauseGame"
        v-show="showTimer && showMenuButtons"
      ></PausePlay>

      <SlideoutMenu
      v-show="showMenuButtons"
      />

      <PauseModal
      v-if="showPauseModal()"
      />

    </div>

  </div>

</template>

<script lang="js">

  import { mapActions, mapState } from 'vuex'
  import Stopwatch from './StopWatch'
  import SlideoutMenu from '@puzzleapps/shared/src/components/ui/SlideoutMenu'
  import HintMenu2 from '@puzzleapps/shared/src/components/ui/HintMenu2'
  import PausePlay from '@puzzleapps/shared/src/components/ui/PausePlay'
  import PauseModal from '@puzzleapps/shared/src/components/ui/PauseModal'

  export default  {
    name: 'game-menu',
    props: [],
    components: {
      SlideoutMenu,
      Stopwatch,
      HintMenu2,
      PausePlay,
      PauseModal,
    },

    data () {
      return {
        themeModal: false,
        supportModal: false,
        menuIsOpen: false,
        pauseModal: false,
      }
    },

    methods: {
      ...mapActions({
        hint: 'game/hint',
        sudokuHint: 'game/sudokuHint',
        codeCrackerHint : 'game/codeCrackerHint',
        setIsPlaying: 'game/setIsPlaying',
        setIsPaused: 'game/setIsPaused',
      }), 

      hintBtn(e) {
        if(this.puzzleType === 'sudoku')
        {
          this.sudokuHint()
        }
        else if(this.puzzleType === 'codecracker')
        {
          this.codeCrackerHint()
        }
        else
        {
          this.hint()
        }
        
        e.target.blur()
      },
      pauseGame(playing){
        if(!this.gameCompleted)
        {
          this.setIsPlaying(playing)
          this.setIsPaused(true)
        }
        
      },
      showPauseModal(){
        return this.isPaused
      },
      showMenuButtons(){
        if(gType === 'trivia')
          return false
        else
          return true
      },

      showMainHintButton(){
        let retVal = true
          
        if(this.puzzleType === 'crossword')
          retVal = false

        if(this.puzzleType === 'wordsearch')
          retVal = false
        return retVal

      }


    },

    computed: {
      ...mapState({
        titleHtml: state => state.game.titleHtml,
        gameMode: state => state.userSettings.gameMode,
        showTimer: state => state.userSettings.showTimer,
        allowHints: state => state.userSettings.allowHints,
        visualGuides: state => state.userSettings.visualGuides,
        hintsUsed: state => state.game.hintsUsed,
        gameType: state => state.game.gameType,
        puzzleType: state => state.game.type,
        isPlaying: state => state.game.isPlaying,
        gameLoaded: state => state.game.gameLoaded,
        gameCompleted: state => state.game.completed,
        gType: state => state.game.type,
        isPaused: state => state.game.isPaused,
      }),

      hintBtnClass(){
        
        return "pe_menu_btn-" + this.gType;
      },

      menuModeTextClass(){
        return "pe_menu_mode-text-" + this.gType;
      }

    }
}

</script>

<style>.pe_logo-cls-1{fill:#e3000c;}</style>

<style scoped lang="scss">

#puzzleapp {


  .pe_game-menu {
    background: var(--title-bar-background-color);
    color: var(--title-bar-color);
    padding-left: 1em;
    border-bottom: 1px solid #ebebeb;
    width: 100%;
    z-index: 999;    
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;    
    height: 2.8em;

    .pe_game-title {
      margin: 0;
    }

    .pe_game-menu-left{
      display: flex;
      justify-content:flex-start;
      align-items: center;
      .pe_menu_mode-text-sudoku{
        color: var(--sudoku-menu-light);
      }
      .pe_menu_mode-text-crossword{
        color: var(--crossword-menu-light);
      }
      .pe_menu_mode-text-codecracker{
        color: var(--codecracker-menu-light);
      }

      .pe_menu_mode-text-wordsearch{
        color: var(--wordsearch-menu-light);
      }
      .pe_menu_mode-text-wheelwords{
        color: var(--wordsearch-menu-light);
      }
    }

    @media (max-width: 690px) {
      .pe_align-center {
        flex: 1;
        justify-content: flex-end;
      }
      .pe_game-title {
        display: none;
      }
      .pe_btn {
        margin: 0!important;
        
      }
    }

    .pe_btn.pe_menu{
      width: 7vw;
      min-width: 40px;
      &.pe_menu_btn-sudoku{
        background: var(--sudoku-menu-btn-background);
        color: var(--sudoku-menu-btn-color);
        &.pe_menu_btn-sudoku:hover{
          background: var(--sudoku-menu-btn-hover);
        }
      }
      &.pe_menu_btn-crossword{
        background: var(--crossword-menu-btn-background);
        color: var(--crossword-menu-btn-color);
        &.pe_menu_btn-crossword:hover{
          background: #000;//var(--crossword-menu-btn-hover);
          color:var(--crossword-menu-btn-background);

        }
      }
      &.pe_menu_btn-codecracker{
        background: var(--codecracker-menu-btn-background);
        color: var(--codecracker-menu-btn-color);
        &.pe_menu_btn-codecracker:hover{
          background: var(--codecracker-menu-btn-hover);
        }
      }
      &.pe_menu_btn-wordsearch{
        background: var(--wordsearch-menu-btn-background);
        color: var(--wordsearch-menu-btn-color);
        &.pe_menu_btn-wordsearch:hover{
          background: var(--wordsearch-menu-btn-hover);
        }
      }
      &.pe_menu_btn-wheelwords{
        background: var(--wordsearch-menu-btn-background);
        color: var(--wordsearch-menu-btn-color);
        &.pe_menu_btn-wheelwords:hover{
          background: var(--wordsearch-menu-btn-hover);
        }
      }

    }
   /* .pe_btn, .pe_hint_btn{
      background: #e72a11;
      color: #0f0d0d;
      border-bottom: solid #fff 1px;
      &.pe_btn_crossword
      {
        background: #ffda85;
        color: #000;
      }
    }*/
    .pe_btn:hover {
      background: #ececec;
      color:#000;
    }
    .pe_btn:active {
      background: #ffda85;
      color:#000;
    }

    .pe_btn.pe_hints-used {
      cursor: auto;
      background: transparent!important;
      margin: 0;
    }

    .pe_stop-watch {
      padding: 0.8em 0 0.8em 0;
    }

    .pe_btn, .pe_stop-watch {
      //font-size: 0.9em;
      margin-left: 0.8em;
    }

  }

  // .pe_btn {
  //   padding: 0.8em;    
  // }

}

</style>
